"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpChain = void 0;
const index_1 = require("./index");
const util_1 = require("./util");
class HttpChain {
    baseUrl;
    options;
    httpOptions;
    constructor(baseUrl, options = index_1.defaultChainOptions, httpOptions = {}) {
        this.baseUrl = baseUrl;
        this.options = options;
        this.httpOptions = httpOptions;
    }
    async info() {
        const chainInfo = await (0, util_1.jsonOrError)(`${this.baseUrl}/info`, this.httpOptions);
        if (!!this.options.chainVerificationParams && !isValidInfo(chainInfo, this.options.chainVerificationParams)) {
            throw Error(`The chain info retrieved from ${this.baseUrl} did not match the verification params!`);
        }
        return chainInfo;
    }
}
exports.HttpChain = HttpChain;
function isValidInfo(chainInfo, validParams) {
    return chainInfo.hash === validParams.chainHash && chainInfo.public_key === validParams.publicKey;
}
class HttpCachingChain {
    baseUrl;
    options;
    chain;
    cachedInfo;
    constructor(baseUrl, options = index_1.defaultChainOptions) {
        this.baseUrl = baseUrl;
        this.options = options;
        this.chain = new HttpChain(baseUrl, options);
    }
    async info() {
        if (!this.cachedInfo) {
            this.cachedInfo = await this.chain.info();
        }
        return this.cachedInfo;
    }
}
exports.default = HttpCachingChain;
//# sourceMappingURL=http-caching-chain.js.map